/**
 * One month of deadlines, read from five tables at once.
 *
 * The kinds are not interchangeable and the screen must never colour them the
 * same: an invoice's date is money expected, a task's is be-finished, a
 * project's is handed-over, a milestone's is a phase closed, and an activity's
 * is talk-to-them-again.
 */
import { api } from "./api";

export const CALENDAR_KINDS = ["task", "milestone", "project", "invoice", "activity"] as const;
export type CalendarKind = (typeof CALENDAR_KINDS)[number];

export interface CalendarItem {
  key: string;
  kind: CalendarKind;
  /** An instant. The screen decides which local day that is. */
  at: string;
  title: string;
  sub: string | null;
  /** Done, paid or cancelled. Still drawn, but quietly. */
  done: boolean;
  to: string | null;
}

export interface CalendarPayload {
  from: string;
  to: string;
  items: CalendarItem[];
  /** What this operator was allowed to read. The legend is built from this, so
   *  it never lists a source the answer could not contain. */
  sources: CalendarKind[];
  counts: Record<CalendarKind, number>;
  truncated: boolean;
}

export const getCalendar = (from: string, to: string, signal?: AbortSignal) =>
  api.get<CalendarPayload>(
    `/admin/crm/calendar?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
    signal,
  );
